import repository from '@/api'
import NotificationLevel from 'eop-ui-core/enumerations/NotificationLevel'
import NotificationChannel from 'eop-ui-core/enumerations/NotificationChannel'

const URI = '/v1/notifications'

export default {
  confirmNotification(notificationId) {
    return repository.post(`${URI}/${notificationId}/confirm`)
  },
  confirmAllNotifications() {
    return repository.post(`${URI}/confirm-all`)
  },
  registerNotifications({ message, receivers, level, channels }: NotificationsOfCreation) {
    return repository.post(`${URI}/bulk`, { message, receivers, level, channels })
  },
}

type NotificationsOfCreation = {
  message: string
  receivers: { name: string; username: string }[]
  level: keyof typeof NotificationLevel
  channels: (keyof typeof NotificationChannel)[]
}
